export default __webpack_public_path__ + "static/media/vose-panel-logo.0af4872f.png";